<div class="flex h-full flex-col">
	<app-symbol-detail-header [symbol]="symbol()" [collapsed]="headerCollapsed()" />
	<div #body class="mt-1.5 flex min-h-0 flex-1 flex-col overflow-y-auto" (scroll)="onBodyScroll(body)">
		<app-symbol-detail-tabs
			class="sticky top-0 z-100 transition-[translate,opacity] duration-300 ease-out"
			[class.-translate-y-full]="headerCollapsed()"
			[class.opacity-0]="headerCollapsed()"
			[attr.aria-hidden]="headerCollapsed()"
			[inert]="headerCollapsed()"
			[(activeTab)]="activeTab"
			(moreSelected)="moreSheet.open()" />
		<app-symbol-detail-more-bottom-sheet
			#moreSheet
			[symbolIsin]="symbolIsin()"
			[imeDetailPageUrl]="symbolMeta()?.imeDetailPageUrl" />
		<div
			role="tabpanel"
			class="mt-1.5 flex flex-1 flex-col pb-1.5"
			[id]="'symbol-detail-panel-' + activeTab()"
			[attr.aria-labelledby]="'symbol-detail-tab-' + activeTab()">
			@switch (activeTab()) {
				@case ('orders') {
					@if (symbolMeta(); as meta) {
						<app-orders class="min-h-0 flex-1" [symbol]="meta.symbol" [managesHeader]="false" />
					}
				}
				@case ('trade-history') {
					@if (symbolMeta(); as meta) {
						<app-trade-history class="min-h-0 flex-1" [contractId]="meta.contractId" />
					}
				}
				@case ('messages') {
					<app-symbol-messages class="min-h-0 flex-1" [symbolIsin]="symbolIsin()" />
				}
				@default {
					<div class="flex flex-col gap-1.5">
						<app-symbol-detail-candle-card
							[symbolMeta]="symbolMeta()"
							[liveMarketView]="liveMarketView()" />
						<market-depth-best-limit
							class="w-full"
							[depthValues]="depthValues()"
							[previousClosePrice]="previousClosePrice()" />

						@for (section of sectionOrder(); track section) {
							@switch (section) {
								@case ('trend-chart') {
									<symbol-trend-chart
										[symbolIsin]="symbolIsin()"
										[marketGroupId]="symbolMeta()?.marketGroupId"
										[lastTradedPrice]="symbol().lastPrice" />
								}
								@case ('symbol-info') {
									<symbol-info [data]="symbolInfoData()" />
								}
							}
						}

						<ui-button
							class="mx-3"
							variant="mute"
							size="md"
							label="ترتیب نمایش جزئیات"
							extraButtonClasses="w-full gap-1 text-3.25"
							data-cy="symbol-detail-sections-button"
							(clicked)="sectionsSheet.open()">
							<ui-icon leftIcon width="20" height="18" iconName="edit-order" aria-hidden="true" />
						</ui-button>

						<app-symbol-detail-sections-bottom-sheet
							#sectionsSheet
							[expanded]="expanded()"
							[sectionOrder]="sectionOrder()"
							(orderChanged)="onSectionOrderChanged($event)"
							(resetRequested)="onLayoutReset()" />
					</div>
				}
			}
		</div>
	</div>
	@if (!ordersToolbarActive()) {
		<app-buy-sell-button [isin]="symbolIsin()" />
	}
</div>
